import type { PatientAISummaryDetail } from "@/types/patient-ai-summary";

import { getPatientAISummary } from "./ai-summary";

export const aiSummaryQueryKeys = {
  all: ["user", "patient", "ai-summary"] as const,
  detail: (patientId: string) =>
    [...aiSummaryQueryKeys.all, patientId] as const,
};

export const aiSummaryQueryOptions = {
  detail: (patientId: string) => ({
    queryKey: aiSummaryQueryKeys.detail(patientId),
    queryFn: () => getPatientAISummary(patientId),
    select: (data: PatientAISummaryDetail | null) => data,
    staleTime: 5 * 60 * 1000, // Consider stale after 5 minutes
    retry: false, // Don't retry on 404
  }),
};
